var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentMethods(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "payment-methods"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29496",
    "data-name": "Rectangle 29496",
    width: 18,
    height: 18,
    transform: "translate(281 314)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_714",
    "data-name": "Mask Group 714",
    transform: "translate(-281 -314)",
    clipPath: "url(#payment-methods)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-05-11T140026.118",
    "data-name": "svgexport-6 - 2022-05-11T140026.118",
    transform: "translate(281 314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14823",
    "data-name": "Group 14823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14822",
    "data-name": "Group 14822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24903",
    "data-name": "Path 24903",
    d: "M16.125,3H1.875A1.878,1.878,0,0,0,0,4.875v8.25A1.878,1.878,0,0,0,1.875,15h14.25A1.878,1.878,0,0,0,18,13.125V4.875A1.878,1.878,0,0,0,16.125,3ZM17.25,13.125a1.126,1.126,0,0,1-1.125,1.125H1.875A1.126,1.126,0,0,1,.75,13.125V4.875A1.126,1.126,0,0,1,1.875,3.75h14.25A1.126,1.126,0,0,1,17.25,4.875v8.25Z",
    fill: "#6a6f73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14825",
    "data-name": "Group 14825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14824",
    "data-name": "Group 14824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24904",
    "data-name": "Path 24904",
    d: "M17.625,5.25H.375A.375.375,0,0,0,0,5.625v2.25a.375.375,0,0,0,.375.375h17.25A.375.375,0,0,0,18,7.875V5.625A.375.375,0,0,0,17.625,5.25ZM17.25,7.5H.75V6h16.5V7.5Z",
    fill: "#6a6f73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14827",
    "data-name": "Group 14827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14826",
    "data-name": "Group 14826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24905",
    "data-name": "Path 24905",
    d: "M7.125,10.5h-4.5a.375.375,0,1,0,0,.75h4.5a.375.375,0,1,0,0-.75Z",
    fill: "#6a6f73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14829",
    "data-name": "Group 14829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14828",
    "data-name": "Group 14828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24906",
    "data-name": "Path 24906",
    d: "M7.125,12h-4.5a.375.375,0,1,0,0,.75h4.5a.375.375,0,0,0,0-.75Z",
    fill: "#6a6f73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14831",
    "data-name": "Group 14831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14830",
    "data-name": "Group 14830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24907",
    "data-name": "Path 24907",
    d: "M14.625,9.75h-.75a1.126,1.126,0,0,0-1.125,1.125v.75a1.126,1.126,0,0,0,1.125,1.125h.75a1.126,1.126,0,0,0,1.125-1.125v-.75A1.126,1.126,0,0,0,14.625,9.75ZM15,11.625a.375.375,0,0,1-.375.375h-.75a.375.375,0,0,1-.375-.375v-.75a.375.375,0,0,1,.375-.375h.75a.375.375,0,0,1,.375.375Z",
    fill: "#6a6f73"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethods);
export default __webpack_public_path__ + "static/media/payment-methods.f97289fc21b242488a38d21be8177022.svg";
export { ForwardRef as ReactComponent };